import { createFileRoute } from '@tanstack/react-router';
import { RequireRole } from '../components/RequireRole';
import { MyRemuneration } from '../features/finance/MyRemuneration';

export const Route = createFileRoute('/ma-remuneration')({
  component: () => (
    <RequireRole allow={['responsable_partenaire', 'responsable_backoffice']}>
      <MyRemuneration />
    </RequireRole>
  ),
});
